//
// Generated class BankMovementConcept
//

/// <reference path="BankMovementConcept_ManagedObject.ts" />

class BankMovementConcept extends BankMovementConcept_ManagedObject
{

}
